
export const topCountries = [
  {
    destination: 'United States',
    img: 'https://cdn.getyourguide.com/img/country/546b6bd65a7c7.jpeg/87.jpg',
  },
  {
    destination: 'Italy',
    img: 'https://cdn.getyourguide.com/img/country/5464f83007564.jpeg/87.jpg',
  },
  {
    destination: 'France',
    img: 'https://cdn.getyourguide.com/img/country/5464f7ddb5189.jpeg/87.jpg',
  },
  {
    destination: 'United Arab Emirates',
    img: 'https://cdn.getyourguide.com/img/country/546b6e7aed75c.jpeg/87.jpg',
  },
  {
    destination: 'Spain',
    img: 'https://cdn.getyourguide.com/img/country/546b6ccc05b7b.jpeg/87.jpg',
  },
  {
    destination: 'United Kingdom',
    img: 'https://cdn.getyourguide.com/img/country/5464f84bc56d4.jpeg/87.jpg',
  },
  {
    destination: 'Greece',
    img: 'https://cdn.getyourguide.com/img/country/576d0c618aee9.jpeg/87.jpg',
  },
  {
    destination: 'Australia',
    img: 'https://cdn.getyourguide.com/img/country/576129bfd94c7.jpeg/87.jpg',
  },
];
